module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" width=\"17\" height=\"17\" viewBox=\"0 0 17 17\"><path fill-rule=\"evenodd\" d=\"M8 8V1.353l8.998-1.362V8H8zM.008 8V2.564L7 1.505V8H.008zM7 9v6.27L.008 14.06V9H7zm9.998 0v8L8 15.443V9h8.998z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/icon/icons/wp.svg
// module id = 894
// module chunks = 0